import { createElement } from 'react';
import { renderToNodeListFactory } from 'fela-bindings';
export default renderToNodeListFactory(createElement);